import { combineReducers } from "redux";
import authReducer, { AuthState } from "./ducks/auth";

export default combineReducers({
  AuthState: authReducer
})

export interface Store {
  AuthState: AuthState
}
